import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

  message: string = '';

  constructor(private bottomSheetRef: MatBottomSheetRef<ConfirmDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public translateService :  TranslateService
    ) { }

  ngOnInit() {
    this.message = this.data && this.data.message;
  }

  confirm() {
    this.bottomSheetRef.dismiss({
      message: 'Confirm',
      data: this.data
    });
  }

  cancel() {
    this.bottomSheetRef.dismiss({
      message: 'Cancel',
      data: this.data
    });
    event.preventDefault();
  }
}
